import React, { useEffect, useState } from "react";
import '../Work-css/Intro.css';
import BG from '../Work-Assets/20240819_212937.jpg';
import Content from './Content';
import Web_buttons from './Web_buttons';
import About_us from './Button_Disp/About_us';
import Clients_img from "./Button_Disp/Clients_img";
import Coop_colors from "../Work-Assets/hostel_adventures_color.png";
import Contacts from "./Button_Disp/Contacts";
import Reviews from "./Button_Disp/Reviews";
import Student_portal from "./Button_Disp/Student_portal";
import Real_Estate_Portal from "./Button_Disp/Real_Estate_Portal";
import School_Portal from "./Button_Disp/School_Portal";
import Marketing_space from "./Button_Disp/Marketing_space";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress, faXmark } from '@fortawesome/free-solid-svg-icons';
import Guiding_and_counsling from "./Button_Disp/Guiding_and_counsling";
import Payment_gateway from "./Payment_Gateway/Payment_gateway";
import Web_buttons_phone from './Web_buttons_phone';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import Update_profile_pic from "./Updates/Update_profile_pic";
import Check_pp from "./Updates/Check_pp";
import Suluhu_main from "./Suluhu_products/Suluhu_main";
import Student_Portal_Sub_Icon from "./Sub_Icons/Student_Portal";
import School_portal_Sub from "./Sub_Icons/School_portal_sub";
import Accomodation_Services from "./Sub_Icons/Accomodation_Services";
import Displays from "./Booking/Displays";
import Hostel_booking from "./Booking/Hostel_booking";
import Tenancy_booking from "./Booking/Tenancy_booking";
import Reporting_date from "./Booking/Reporting_date";
import SPA from "./Booking/SPA";
import SPA_fills from "./Booking/SPA_fills";
import Logo from "./Button_Disp/Logo";
import Scholarship_intro from "./Scholarship_application/Others/Scholarship_intro"
import MultiImageUpload from "./Scholarship_application/Others/Multiple_images";

function Intro() {

  const [about, setAbout] = useState(false)
  const [clients, setClients] = useState(false)
  const [contacts, setContacts] = useState(false)
  const [Revs, setRevs] = useState(false)
  const [stude_P, setStudentP] = useState(false)
  const [real_estate_portal, setREP] = useState(false)
  const [school_portal, setSP] = useState(false)
  const [marketing_port, setMarketing_port] = useState(false)
  const [guidance, setGuidance] = useState(false)
  const [payementgateway, setPaymentGW] = useState(false)
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [opt, setOPT] = useState(false)
  const [update_pp, setUpdatepp] = useState(false)
  const [suluhu, setSuluhu] = useState(false)

  const [student_protal_sub, setSPS] = useState(false)
  const [schoo_portal_btn, setSPBTN] = useState(false)
  const [acc_services, setAcc_Services] = useState(false)

  const [booking, setBooking] = useState(false)
  const [hostel_booking, setHostelbooking] = useState(false)
  const [tenancybooking, setTenancybooking] = useState(false)
  const [exp_date, setExpdate] = useState(false)
  const [SPAs, setSPA] = useState(false)
  const [spa_fills, setSpafills] = useState(false)
  const [scholarship_application, setScholarship] = useState(false)
  const [short_term_type, setShortTT] = useState('')

  const [logo_set, setLogo_set] = useState(false)

  const close = () =>
    {
      setSP(false)
      setREP(false)
      setStudentP(false)
      setGuidance(false)
      setRevs(false)
      setPaymentGW(false)
      setSuluhu(false)

      setSPBTN(false)
      setSPS(false)
      setAcc_Services(false)

      setHostelbooking(false)
      setBooking(false)
      setTenancybooking(false)
      setExpdate(false)
      setSPA(false)

      setLogo_set(false)
      setScholarship(false)

    }

    const close_spa = () =>{
      setSPA(true)
      setSpafills(false)
    }

    useEffect(() => {

      if(opt==true)
      {
        setIsDivVisible(true);
      }
      
      if(opt==false)
      {
        setIsDivVisible(false);
      } 
      
    }, [opt, isDivVisible]);





  return (
    <div className='whole_Intro'>
        <div className='BG_IMG_TT'>
            <img className='IMG_BG' src={BG} />
        </div>

        <div className="coop_col">
          <img src={Coop_colors} />
        </div>

        <div className="coop_bars">

        <div className="green_COOP_Bar"></div>
          
          
          <div className="black_COOP_Bar"></div>
          <div className="white_COOP_Bar"></div>
          <div className="blue_COOP_Bar"></div>
          
        </div>

        <div className='Content'>

          
        <div className='buttons_WEB'>
          <Web_buttons 
          setTenancybooking={setTenancybooking} 
          setHostelbooking = {setHostelbooking}
          setBooking = {setBooking}
          setExpdate = {setExpdate}
          setLogo_set = {setLogo_set}
          setScholarship = {setScholarship}
          setSuluhu={setSuluhu} ms={setMarketing_port} payementgateway={setPaymentGW} about={setAbout} client={setClients} revs={setRevs} contacts={setContacts} school_portal={setSP} stude_P={setStudentP} real_estate_portal={setREP} rock={setGuidance} />
          {/* <Web_buttons setSPS={setSPS} setSPBTN={setSPBTN} setAcc_Services={setAcc_Services} />**/}
        </div>
        <div className="inner_Cont">
            <div className='heading'>
               {/**<div className='welcome'>Hostel Adventures</div>**/} 
            </div>
            
            <div className='cont_TAG'><Content /></div>
            </div>
        </div>
      
        <Check_pp setUpdatepp={setUpdatepp} />

         {spa_fills?(<div className="SP_BG"><FontAwesomeIcon icon={faXmark} onClick={close_spa} className='close_PORTALS_RE' />
          <SPA_fills short_term_type={short_term_type} setSpafills={setSpafills} setSPA={setSPA} />
         </div>
         ):('')}

          {SPAs?(
          <div className="SP_BG"><FontAwesomeIcon icon={faXmark} className='close_PORTALS_RE' onClick={close} />
          <SPA setSPA={setSPA} setBooking={setBooking} setSpafills={setSpafills} setShortTT={setShortTT}
     
          /></div>):('')}
    
        
          {booking?(<div className="SP_BG"><FontAwesomeIcon icon={faXmark} className='close_PORTALS_RE' onClick={close} />
          <Displays 
          setTenancybooking={setTenancybooking} 
          setHostelbooking = {setHostelbooking}
          setBooking = {setBooking}
          setExpdate = {setExpdate}
          setSPA={setSPA}
          /></div>):('')}
    
        {exp_date?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Reporting_date /></div>):('')}
        
        {hostel_booking?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Hostel_booking setHostelbooking={setHostelbooking} /></div>):('')}
        {tenancybooking?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Tenancy_booking setTenancybooking={setTenancybooking} /></div>):('')}
        
        {guidance==true?(<div className="SP_BG"><FontAwesomeIcon icon={faXmark} className='close_PORTALS_RE' onClick={close} /><Guiding_and_counsling rock={setGuidance} /></div>):('')}
        {about==true?(<div className='About_us'><About_us about={setAbout} /></div>):('')}
        {clients==true?(<div className='About_us'><Clients_img client={setClients} /></div>):('')}
        {contacts==true?(<div className="contacts_BG"><Contacts contacts={setContacts} /></div>):('')}
        {Revs==true?(<div className="revs_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Reviews revs={setRevs} /></div>):('')}
        {stude_P==true?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Student_portal stude_P={setStudentP} /></div>):('')}
        {real_estate_portal==true?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Real_Estate_Portal real_estate_portal={setREP} /></div>):('')}
        {school_portal==true?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><School_Portal school_portal={setSP} /></div>):('')}
        {marketing_port==true?(<div className='About_us'><Marketing_space ms={setMarketing_port} /></div>):('')}
        {payementgateway==true?(<div className="revs_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Payment_gateway /></div>):('')}
        {update_pp?(<div className="SP_BG"><Update_profile_pic setUpdatepp={setUpdatepp} /></div>):('')}
        {suluhu?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Suluhu_main /></div>):('')}
        {student_protal_sub?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Student_Portal_Sub_Icon setSPS={setSPS} setSuluhu={setSuluhu} ms={setMarketing_port} payementgateway={setPaymentGW} about={setAbout} client={setClients} revs={setRevs} contacts={setContacts} school_portal={setSP} stude_P={setStudentP} real_estate_portal={setREP} rock={setGuidance} /></div>):('')}
        {schoo_portal_btn?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><School_portal_Sub setSPBTN={setSPBTN} setSuluhu={setSuluhu} ms={setMarketing_port} payementgateway={setPaymentGW} about={setAbout} client={setClients} revs={setRevs} contacts={setContacts} school_portal={setSP} stude_P={setStudentP} real_estate_portal={setREP} rock={setGuidance} /></div>):('')}
        {acc_services?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Accomodation_Services setAcc_Services={setAcc_Services} setSuluhu={setSuluhu} ms={setMarketing_port} payementgateway={setPaymentGW} about={setAbout} client={setClients} revs={setRevs} contacts={setContacts} school_portal={setSP} stude_P={setStudentP} real_estate_portal={setREP} rock={setGuidance} /></div>):('')}
        {logo_set?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Logo setLogo_set={setLogo_set} setSuluhu={setSuluhu} /></div>):('')}
        {scholarship_application?(<div className="SP_BG"><FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} /><Scholarship_intro setScholarship={setScholarship} /></div>):('')}
        
        
        
        
        <div className={`web_phone ${isDivVisible ? 'visible' : ''}`}><Web_buttons_phone 
               setTenancybooking={setTenancybooking} 
               setHostelbooking = {setHostelbooking}
               setBooking = {setBooking}
               setLogo_set={setLogo_set}
               setScholarship = {setScholarship}    
               setSuluhu={setSuluhu} ms={setMarketing_port} payementgateway={setPaymentGW} about={setAbout} client={setClients} revs={setRevs} contacts={setContacts} school_portal={setSP} stude_P={setStudentP} real_estate_portal={setREP} rock={setGuidance}opt={setOPT} /></div>
        
       </div>
  )
}

export default Intro
